import * as _ from "lodash";

import {
  DATEFORMAT_EN_CA,
  DATEFORMAT_EN_US,
  DATEFORMAT_ES_US,
  DATEFORMAT_CN,
  DATEFORMAT_CZ,
  DATEFORMAT_JP,
  DATEFORMAT_EN,
  DATEFORMAT_FR,
  DATEFORMAT_DE,
  DATEFORMAT_HE,
  DATEFORMAT_ID,
  DATEFORMAT_IT,
  DATEFORMAT_IS,
  DATEFORMAT_PT,
  DATEFORMAT_TR,
  DATEFORMAT_RU,
  DATEFORMAT_ES,
  DATEFORMAT_UA,
  DATEFORMAT_DK,
  DATEFORMAT_FI,
  DATEFORMAT_KR,
  DATEFORMAT_NL,
  DATEFORMAT_NO,
  DATEFORMAT_PL,
  DATEFORMAT_SE,
  DATEFORMAT_GR,
  DATEFORMAT_BG,
  DATEFORMAT_HR,
  DATEFORMAT_EE,
  DATEFORMAT_IE,
  DATEFORMAT_HU,
  DATEFORMAT_LV,
  DATEFORMAT_LI,
  DATEFORMAT_LU,
  DATEFORMAT_MT,
  DATEFORMAT_RO,
  DATEFORMAT_SK,
  DATEFORMAT_SI,
  DATEFORMAT_IN,
  DATEFORMAT_BD,
  DATEFORMAT_SW,
  DATEFORMAT_AR,
  DATEFORMAT_PK,
  DATEFORMAT_IR,
  DATEFORMAT_VN,
  DATEFORMAT_IM,
  DATEFORMAT_MY,
  DATEFORMAT_MM,
  DATEFORMAT_PH,
  DATEFORMAT_TH,
  DATEFORMAT_GL,
  DATEFORMAT_FO,
  DATEFORMAT_TAMIL,
  DATEFORMAT_MARATHI,
  DATEFORMAT_TELUGU,
  DATEFORMAT_GUJARATI,
  DATEFORMAT_PUNJABI,
  DATEFORMAT_JAVANESE,
  DATEFORMAT_WALES,
  DATEFORMAT_SCOTLAND,
  DATEFORMAT_MAORI1,
  DATEFORMAT_MAORI2
} from './constants';

import {
  getDateFormat
} from "./settings";

export const getLocale = () => {
  return LOCALES[getDateFormat()];
};

export const getLocaleIsRtl = () => {
  return !!getLocale().rtl;
};

export const getLocaleShortMonth = (n) => {
  return getLocale().shortMonths[n];
};

export const getLocaleLongMonth = (n) => {
  return getLocale().longMonths[n];
};

export const getLocaleLongWeekday = (n) => {
  return getLocale().longWeekdays[n];
};

export const getLocaleShortWeekday = (n) => {
  return getLocale().shortWeekdays[n];
};

export const COUNTRY_CA = "CA";
export const COUNTRY_GB = "GB";
export const COUNTRY_IE = "IE";
export const COUNTRY_US = "US";
export const COUNTRY_NZ = "NZ";

export const COUNTRY_NO = "NO";
export const COUNTRY_SE = "SE";
export const COUNTRY_DK = "DK";
export const COUNTRY_GL = "GL";
export const COUNTRY_FO = "FO";
export const COUNTRY_IS = "IS";

export const COUNTRY_IN = "IN";
export const COUNTRY_PK = "PK";
export const COUNTRY_ID = "ID";
export const COUNTRY_SG = "SG";
export const COUNTRY_MY = "MY";

export const LOCALE_DESC_MAP = {
  [DATEFORMAT_EN]: "English (International)",
  [DATEFORMAT_EN_US]: "English (USA)",
  [DATEFORMAT_EN_CA]: "English (Canada)",
  [DATEFORMAT_ID]: "Bahasa Indonesia ",
  [DATEFORMAT_CZ]: "Čeština ",
  [DATEFORMAT_DK]: "Dansk",
  [DATEFORMAT_DE]: "Deutsch",
  [DATEFORMAT_ES]: "Español (Internacional)",
  [DATEFORMAT_ES_US]: "Español (USA)",
  [DATEFORMAT_FR]: "Français",
  [DATEFORMAT_IT]: "Italiano",
  [DATEFORMAT_NL]: "Nederlands",
  [DATEFORMAT_NO]: "Norsk",
  [DATEFORMAT_PL]: "Polski",
  [DATEFORMAT_PT]: "Português",
  [DATEFORMAT_FI]: "Suomi",
  [DATEFORMAT_SE]: "Svenska",
  [DATEFORMAT_TR]: "Türkçe",
  [DATEFORMAT_GR]: "Ελληνικά",
  [DATEFORMAT_HE]: "עִבְרִית‎",
  [DATEFORMAT_RU]: "Русские",
  [DATEFORMAT_UA]: "Українська",
  [DATEFORMAT_JP]: "日本語",
  [DATEFORMAT_KR]: "한국어",
  [DATEFORMAT_CN]: "中文",
  [DATEFORMAT_BG]: "български",
  [DATEFORMAT_HR]: "Hrvatski",
  [DATEFORMAT_EE]: "Eesti keel",
  [DATEFORMAT_IE]: "Gaeilge",
  [DATEFORMAT_HU]: "Magyar nyelv",
  [DATEFORMAT_LV]: "Lettish",
  [DATEFORMAT_LI]: "Lietuvių",
  [DATEFORMAT_LU]: "Lëtzebuergesch",
  [DATEFORMAT_IS]: "Íslenska",
  [DATEFORMAT_MAORI1]: "Māori (Kupu Arotau)",
  [DATEFORMAT_MAORI2]: "Māori (Ngā Rā o te Wiki)",
  [DATEFORMAT_IM]: "Manx",
  [DATEFORMAT_MT]: "Malti",
  [DATEFORMAT_RO]: "Română",
  [DATEFORMAT_SK]: "Slovenský",
  [DATEFORMAT_SI]: "Slovenščina",
  [DATEFORMAT_IN]: "हिन्दी",
  [DATEFORMAT_BD]: "বাংলা",
  [DATEFORMAT_SW]: "Swahili",
  [DATEFORMAT_AR]: "العربية الفصحى",
  [DATEFORMAT_PK]: "اردو",
  [DATEFORMAT_IR]: "فارسی",
  [DATEFORMAT_VN]: "Riếng Việt",
  [DATEFORMAT_MY]: "Bahasa Melayu",
  [DATEFORMAT_MM]: "မြန်မာစာ",
  [DATEFORMAT_PH]: "Wikang Filipino",
  [DATEFORMAT_TH]: "ภาษาไทย",
  [DATEFORMAT_GL]: "Kalaallisut",
  [DATEFORMAT_FO]: "Føroyskt mál",
  [DATEFORMAT_WALES]: "Cymraeg",
  [DATEFORMAT_SCOTLAND]: "Gàidhlig",
  [DATEFORMAT_MARATHI]: "मराठी",
  [DATEFORMAT_TELUGU]: "తెలుగు",
  [DATEFORMAT_GUJARATI]: "ગુજરાત",
  [DATEFORMAT_PUNJABI]: "ਪੰਜਾਬੀپَن٘جابی",
  [DATEFORMAT_JAVANESE]: "ꦧꦱꦗꦮ",
  [DATEFORMAT_TAMIL]: "தமிழ்",
};

const FLAG_AU = "🇦🇺";
const FLAG_NZ = "🇳🇿";
const FLAG_CA = "🇨🇦";
const FLAG_IE = "🇮🇪";
const FLAG_ENGLAND = "🏴󠁧󠁢󠁥󠁮󠁧󠁿";
const FLAG_TAIWAN = "🇹🇼";
const FLAG_LU = "🇱🇺"; // Luxembourg
const FLAG_BE = "🇧🇪"; // Belgium
const FLAG_CH = "🇨🇭"; // Switzerland
const FLAG_BR = "🇧🇷"; // Brazil
const FLAG_AT = "🇦🇹"; // Austria
const FLAG_LI = "🇱🇮"; // Liechtenstein
const FLAG_MX = "🇲🇽"; // Mexico
const FLAG_CO = "🇨🇴"; // Colombia
const FLAG_AR = "🇦🇷"; // Argentina
const FLAG_PE = "🇵🇪"; // Peru
const FLAG_VE = "🇻🇪"; // Venezuela
const FLAG_CL = "🇨🇱"; // Chile
const FLAG_GT = "🇬🇹"; // Guatemala
const FLAG_EC = "🇪🇨"; // Ecuador
const FLAG_BO = "🇧🇴"; // Bolivia
const FLAG_CU = "🇨🇺"; // Cuba
const FLAG_DO = "🇩🇴"; // Dominican Republic
const FLAG_HN = "🇭🇳"; // Honduras
const FLAG_PY = "🇵🇾"; // Paraguay
const FLAG_NI = "🇳🇮"; // Nicaragua
const FLAG_SV = "🇸🇻"; // El Salvador
const FLAG_CR = "🇨🇷"; // Costa Rica
const FLAG_UY = "🇺🇾"; // Uruguay
const FLAG_MY = "🇲🇾"; // Malaysia
const FLAG_IN = "🇮🇳"; // India
const FLAG_PK = "🇵🇰"; // Pakistan
const FLAG_LK = "🇱🇰"; // Sri Lanka
const FLAG_ID = "🇮🇩"; // Indonesia
const FLAG_SG = "🇸🇬"; // Singapore

const LOCALE_FLAG_MAP = {
  [DATEFORMAT_EN]: {
    DEFAULT: "🇬🇧",
    "Australia/Adelaide": FLAG_AU,
    "Australia/Brisbane": FLAG_AU,
    "Australia/Broken_Hill": FLAG_AU,
    "Australia/Darwin": FLAG_AU,
    "Australia/Eucla": FLAG_AU,
    "Australia/Hobart": FLAG_AU,
    "Australia/Lindeman": FLAG_AU,
    "Australia/Lord_Howe": FLAG_AU,
    "Australia/Melbourne": FLAG_AU,
    "Australia/Perth": FLAG_AU,
    "Australia/Sydney": FLAG_AU,
    //NZ
    "Pacific/Auckland": FLAG_NZ,
    "Pacific/Chatham": FLAG_NZ,
    //England
    "Europe/London": FLAG_ENGLAND,
    "Europe/Dublin": FLAG_IE,
  },
  [DATEFORMAT_EN_US]: "🇺🇸",
  [DATEFORMAT_EN_CA]: FLAG_CA,
  [DATEFORMAT_ID]: FLAG_ID,
  [DATEFORMAT_CZ]: "🇨🇿",
  [DATEFORMAT_DE]: {
    DEFAULT: "🇩🇪",
    "Europe/Vienna": FLAG_AT,
    "Europe/Vaduz": FLAG_LI,
    "Europe/Zurich": FLAG_CH,
    "Europe/Brussels": FLAG_BE,
    "Europe/Luxembourg": FLAG_LU,
  },
  [DATEFORMAT_ES]: {
    //Panama and Puerto Rico us US format as well as others
    DEFAULT: "🇪🇸",
    "America/Bahia_Banderas": FLAG_MX,
    "America/Cancun": FLAG_MX,
    "America/Chihuahua": FLAG_MX,
    "America/Hermosillo": FLAG_MX,
    "America/Matamoros": FLAG_MX,
    "America/Mazatlan": FLAG_MX,
    "America/Merida": FLAG_MX,
    "America/Mexico_City": FLAG_MX,
    "America/Monterrey": FLAG_MX,
    "America/Ojinaga": FLAG_MX,
    "America/Tijuana": FLAG_MX,
    "America/Bogota": FLAG_CO,
    "America/Argentina/Buenos_Aires,": FLAG_AR,
    "America/Argentina/Catamarca,": FLAG_AR,
    "America/Argentina/Cordoba,": FLAG_AR,
    "America/Argentina/Jujuy,": FLAG_AR,
    "America/Argentina/La_Rioja,": FLAG_AR,
    "America/Argentina/Mendoza,": FLAG_AR,
    "America/Argentina/Rio_Gallegos,": FLAG_AR,
    "America/Argentina/Salta,": FLAG_AR,
    "America/Argentina/San_Juan,": FLAG_AR,
    "America/Argentina/San_Luis,": FLAG_AR,
    "America/Argentina/Tucuman,": FLAG_AR,
    "America/Argentina/Ushuaia,": FLAG_AR,
    "America/Lima": FLAG_PE,
    "America/Caracas": FLAG_VE,
    "America/Punta_Arenas": FLAG_CL,
    "America/Santiago": FLAG_CL,
    "Pacific/Easter": FLAG_CL,
    "America/Guatemala": FLAG_GT,
    "America/Guayaquil": FLAG_EC,
    "Pacific/Galapagos": FLAG_EC,
    "America/La_Paz": FLAG_BO,
    "America/Havana": FLAG_CU,
    "America/Santo_Domingo": FLAG_DO,
    "America/Tegucigalpa": FLAG_HN,
    "America/Asuncion": FLAG_PY,
    "America/Managua": FLAG_NI,
    "America/El_Salvador": FLAG_SV,
    "America/Costa_Rica": FLAG_CR,
    "America/Montevideo": FLAG_UY,
  },
  [DATEFORMAT_ES_US]: "🇺🇸",
  [DATEFORMAT_FR]: {
    DEFAULT: "🇫🇷",
    "Europe/Luxembourg": FLAG_LU,
    "Europe/Brussels": FLAG_BE,
    "Europe/Zurich": FLAG_CH,
    "America/Atikokan": FLAG_CA,
    "America/Blanc": FLAG_CA,
    "America/Cambridge_Bay": FLAG_CA,
    "America/Costa_Rica": FLAG_CA,
    "America/Creston": FLAG_CA,
    "America/Dawson": FLAG_CA,
    "America/Dawson_Creek": FLAG_CA,
    "America/Edmonton": FLAG_CA,
    "America/Fort_Nelson": FLAG_CA,
    "America/Glace_Bay": FLAG_CA,
    "America/Goose_Bay": FLAG_CA,
    "America/Halifax": FLAG_CA,
    "America/Inuvik": FLAG_CA,
    "America/Iqaluit": FLAG_CA,
    "America/Moncton": FLAG_CA,
    "America/Nipigon": FLAG_CA,
    "America/Pangnirtung": FLAG_CA,
    "America/Rainy_River": FLAG_CA,
    "America/Rankin_Inlet": FLAG_CA,
    "America/Regina": FLAG_CA,
    "America/Resolute": FLAG_CA,
    "America/St_Johns": FLAG_CA,
    "America/Swift_Current": FLAG_CA,
    "America/Thunder_Bay": FLAG_CA,
    "America/Toronto": FLAG_CA,
    "America/Vancouver": FLAG_CA,
    "America/Whitehorse": FLAG_CA,
    "America/Winnipeg": FLAG_CA,
    "America/Yellowknife": FLAG_CA,
  },
  [DATEFORMAT_IT]: {
    DEFAULT: "🇮🇹",
    "Europe/Zurich": FLAG_CH,
  },
  [DATEFORMAT_PT]: {
    DEFAULT: "🇵🇹",
    "America/Araguaina": FLAG_BR,
    "America/Bahia": FLAG_BR,
    "America/Belem": FLAG_BR,
    "America/Boa_Vista": FLAG_BR,
    "America/Campo_Grande": FLAG_BR,
    "America/Cuiaba": FLAG_BR,
    "America/Eirunepe": FLAG_BR,
    "America/Fortaleza": FLAG_BR,
    "America/Maceio": FLAG_BR,
    "America/Manaus": FLAG_BR,
    "America/Noronha": FLAG_BR,
    "America/Porto_Velho": FLAG_BR,
    "America/Recife": FLAG_BR,
    "America/Rio_Branco": FLAG_BR,
    "America/Santarem": FLAG_BR,
    "America/Sao_Paulo": FLAG_BR,
  },
  [DATEFORMAT_TR]: "🇹🇷",
  [DATEFORMAT_HE]: "🇮🇱",
  [DATEFORMAT_RU]: "🇷🇺",
  [DATEFORMAT_UA]: "🇺🇦",
  [DATEFORMAT_JP]: "🇯🇵",
  [DATEFORMAT_DK]: {
    DEFAULT: "🇩🇰",
    "Europe/Brussels": FLAG_BE,
  },
  [DATEFORMAT_FI]: "🇫🇮",
  [DATEFORMAT_KR]: "🇰🇷",
  [DATEFORMAT_NL]: "🇳🇱",
  [DATEFORMAT_NO]: "🇳🇴",
  [DATEFORMAT_PL]: "🇵🇱",
  [DATEFORMAT_SE]: "🇸🇪",
  [DATEFORMAT_GR]: "🇬🇷",
  [DATEFORMAT_CN]: {
    DEFAULT: "🇨🇳",
    "Asia/Taipei": FLAG_TAIWAN,
    "Asia/Kuala_Lumpur": FLAG_MY,
    "Asia/Kuching": FLAG_MY,
    "Asia/Singapore": FLAG_SG,
  },
  [DATEFORMAT_BG]: "🇧🇬",
  [DATEFORMAT_HR]: "🇭🇷",
  [DATEFORMAT_EE]: "🇪🇪",
  [DATEFORMAT_IE]: FLAG_IE,
  [DATEFORMAT_HU]: "🇭🇺",
  [DATEFORMAT_LV]: "🇱🇻",
  [DATEFORMAT_LI]: "🇱🇹",
  [DATEFORMAT_MT]: "🇲🇹",
  [DATEFORMAT_RO]: "🇷🇴",
  [DATEFORMAT_SK]: "🇸🇰",
  [DATEFORMAT_SI]: "🇸🇮",
  [DATEFORMAT_LU]: "🇱🇺",
  [DATEFORMAT_IS]: "🇮🇸",
  [DATEFORMAT_IM]: "🇮🇲",
  [DATEFORMAT_MAORI1]: FLAG_NZ,
  [DATEFORMAT_MAORI2]: FLAG_NZ,
  [DATEFORMAT_WALES]: "🏴󠁧󠁢󠁷󠁬󠁳󠁿",
  [DATEFORMAT_SCOTLAND]: "🏴󠁧󠁢󠁳󠁣󠁴󠁿",
  [DATEFORMAT_IN]: FLAG_IN,
  [DATEFORMAT_BD]: "🇧🇩",
  [DATEFORMAT_SW]: "🌍",
  [DATEFORMAT_AR]: "🌍",
  [DATEFORMAT_PK]: FLAG_PK,
  [DATEFORMAT_IR]: "🇮🇷",
  [DATEFORMAT_VN]: "🇻🇳",
  [DATEFORMAT_MY]: {
    DEFAULT: FLAG_MY,
    "Asia/Singapore": FLAG_SG,
    "Asia/Jakarta": FLAG_ID,
    "Asia/Jayapura": FLAG_ID,
    "Asia/Makassar": FLAG_ID,
    "Asia/Pontianak": FLAG_ID,
  },
  [DATEFORMAT_MM]: "🇲🇲",
  [DATEFORMAT_PH]: "🇵🇭",
  [DATEFORMAT_TH]: "🇹🇭",
  [DATEFORMAT_GL]: "🇬🇱",
  [DATEFORMAT_TAMIL]: {
    DEFAULT: FLAG_IN,
    "Asia/Colombo": FLAG_LK,
    "Asia/Kuala_Lumpur": FLAG_MY,
    "Asia/Kuching": FLAG_MY,
    "Asia/Singapore": FLAG_SG,
  },
  [DATEFORMAT_FO]: "🇫🇴",
  [DATEFORMAT_MARATHI]: FLAG_IN,
  [DATEFORMAT_TELUGU]: FLAG_IN,
  [DATEFORMAT_GUJARATI]: {
    DEFAULT: FLAG_IN,
    "Asia/Karachi": FLAG_PK,
  },
  [DATEFORMAT_PUNJABI]: {
    DEFAULT: FLAG_PK,
    "Asia/Kolkata": FLAG_IN,
    "Asia/Calcutta": FLAG_IN, // not found in zones (something that OSX produced)
  },
  [DATEFORMAT_JAVANESE]: FLAG_ID,
};

// https://www.fincher.org/Utilities/CountryLanguageList.shtml
// https://en.wikipedia.org/wiki/Date_format_by_country

export const DATEFORMAT_DMY = "D/M/Y";
export const DATEFORMAT_MDY = "M/D/Y";
export const DATEFORMAT_YMD = "Y-M-D";

export const getDateFormatDescription = (dateFormat) => {
  const df = LOCALES[dateFormat];
  if (!df || df.formatYMD) {
    return [DATEFORMAT_YMD];
  }
  if (df.formatMDY) {
    if (df.formatDMY) {
      // eg Canada
      return [DATEFORMAT_DMY, DATEFORMAT_MDY, DATEFORMAT_YMD];
    }
    return [DATEFORMAT_MDY, DATEFORMAT_YMD];
  }
  return [DATEFORMAT_DMY, DATEFORMAT_YMD];
};

export const getLanguageFlag = _.memoize((dateFormat) => {
  const item = LOCALE_FLAG_MAP[dateFormat];
  if (typeof item === "string") {
    return item;
  }
  if (typeof item === "object") {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (item[timezone]) {
      return item[timezone];
    }
    return item.DEFAULT || "";
  }
  return "";
});

export const estimateUserCountry = () => {
  try {
    switch (Intl.DateTimeFormat().resolvedOptions().timeZone) {
      case "America/Adak":
      case "America/Anchorage":
      case "America/Boise":
      case "America/Chicago":
      case "America/Denver":
      case "America/Detroit":
      case "America/Indiana":
      case "America/Indiana/Indianapolis":
      case "America/Indiana/Knox":
      case "America/Indiana/Marengo":
      case "America/Indiana/Petersburg":
      case "America/Indiana/Tell_City":
      case "America/Indiana/Vevay":
      case "America/Indiana/Vincennes":
      case "America/Indiana/Winamac":
      case "America/Juneau":
      case "America/Kentucky":
      case "America/Kentucky/Louisville":
      case "America/Kentucky/Monticello":
      case "America/Los_Angeles":
      case "America/Manaus":
      case "America/Menominee":
      case "America/Metlakatla":
      case "America/New_York":
      case "America/Nome":
      case "America/North_Dakota":
      case "America/North_Dakota/Beulah":
      case "America/North_Dakota/Center":
      case "America/North_Dakota/New_Salem":
      case "America/Phoenix":
      case "America/Sitka":
      case "America/Yakutat":
        return COUNTRY_US;
      case "America/Atikokan":
      case "America/Blanc":
      case "America/Cambridge_Bay":
      case "America/Costa_Rica":
      case "America/Creston":
      case "America/Dawson":
      case "America/Dawson_Creek":
      case "America/Edmonton":
      case "America/Fort_Nelson":
      case "America/Glace_Bay":
      case "America/Goose_Bay":
      case "America/Halifax":
      case "America/Inuvik":
      case "America/Iqaluit":
      case "America/Moncton":
      case "America/Nipigon":
      case "America/Pangnirtung":
      case "America/Rainy_River":
      case "America/Rankin_Inlet":
      case "America/Regina":
      case "America/Resolute":
      case "America/St_Johns":
      case "America/Swift_Current":
      case "America/Thunder_Bay":
      case "America/Toronto":
      case "America/Vancouver":
      case "America/Whitehorse":
      case "America/Winnipeg":
      case "America/Yellowknife":
        return COUNTRY_CA;

      case "Europe/London":
        return COUNTRY_GB;

      case "Europe/Dublin":
        return COUNTRY_IE;

      case "Europe/Oslo":
        return COUNTRY_NO;
      case "Europe/Stockholm":
        return COUNTRY_SE;
      case "Europe/Copenhagen":
        return COUNTRY_DK;
      case "America/Nuuk":
      case "America/Danmarkshavn":
      case "America/Scoresbysund":
      case "America/Thule":
      case "America/Godthab": // not found in zones (something that OSX produced)
        return COUNTRY_GL;
      case "Atlantic/Reykjavik":
        return COUNTRY_IS;
      case "Atlantic/Faroe":
        return COUNTRY_FO;
      case "Asia/Kolkata":
      case "Asia/Calcutta": // not found in zones (something that OSX produced)
        return COUNTRY_IN;
      case "Asia/Karachi":
        return COUNTRY_PK;
      case "Asia/Jakarta":
      case "Asia/Jayapura":
      case "Asia/Makassar":
      case "Asia/Pontianak":
        return COUNTRY_ID;
      case "Asia/Singapore":
        return COUNTRY_SG;
      case "Asia/Kuala_Lumpur":
      case "Asia/Kuching":
        return COUNTRY_MY;
      case "Pacific/Auckland":
      case "Pacific/Chatham":
        return COUNTRY_NZ;

      default: {
        // noop
      }
    }
  } catch (ignore) {}

  return null;
};

/*
(function () {
  try {
    const getFormats = (formatCode) => {
      const longWeekdays = [];
      const shortWeekdays = [];
      const longMonths = [];
      const shortMonths = [];

      for (let i = 0; i < 12; i++) {
        const d = new Date();
        d.setDate(1);
        d.setFullYear(2001);
        d.setMonth(i);

        const longMonth = new Intl.DateTimeFormat(formatCode, {
          month: "long",
        }).format(d);
        const shortMonth = new Intl.DateTimeFormat(formatCode, {
          month: "short",
        }).format(d);

        longMonths[i] = longMonth;
        shortMonths[i] = shortMonth;
      }

      for (let i = 0; i < 7; i++) {
        const d = new Date();
        d.setDate(1);
        d.setFullYear(2001); // year started in a Sunday
        d.setMonth(0);
        d.setDate(i);

        const longWeekday = new Intl.DateTimeFormat(formatCode, {
          weekday: "long",
        }).format(d);
        const shortWeekday = new Intl.DateTimeFormat(formatCode, {
          weekday: "short",
        }).format(d);

        longWeekdays[i] = longWeekday;
        shortWeekdays[i] = shortWeekday;
      }

      return {
        code: formatCode,
        longWeekdays,
        shortWeekdays,
        longMonths,
        shortMonths,
      };
    };

    const formatStr = (obj) => {
      return (
        "  {\n    " +
        Object.keys(obj)
          .map((key) => key + ": " + JSON.stringify(obj[key]))
          .join(",\n    ") +
        "\n  },"
      );
    };

    const LANGS = ["lb"];
    LANGS.forEach((code) => {
      console.log(formatStr(getFormats(code)));
    });
  } catch (ignore) {}
})();
/* */
/*
const options = {
  month: "long",
  /*
  year: "2-digit",
  month: "long",
  day: "numeric",
  hour: "numeric",
  minute: "numeric",
  second: "numeric",
  weekday: "long",
  hour12: true,
  timeZone: 'America/Santiago'
  *\/
};
*/

const LOCALE_EN = {
  longWeekdays: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ],
  shortWeekdays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  longMonths: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ],
  shortMonths: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ],
};

const LOCALE_ES = {
  longWeekdays: [
    "domingo",
    "lunes",
    "martes",
    "miércoles",
    "jueves",
    "viernes",
    "sábado",
  ],
  shortWeekdays: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
  longMonths: [
    "enero",
    "febrero",
    "marzo",
    "abril",
    "mayo",
    "junio",
    "julio",
    "agosto",
    "septiembre",
    "octubre",
    "noviembre",
    "diciembre",
  ],
  shortMonths: [
    "ene",
    "feb",
    "mar",
    "abr",
    "may",
    "jun",
    "jul",
    "ago",
    "sept",
    "oct",
    "nov",
    "dic",
  ],
};

// en-AU
export const LOCALES = {
  // English (all)
  EN: LOCALE_EN,

  EN_US: {
    ...LOCALE_EN,
    formatDMY: false,
    formatMDY: true,
  },

  EN_CA: {
    ...LOCALE_EN,
    formatDMY: true,
    formatMDY: true,
  },

  // Spanish
  // es-ES
  ES: LOCALE_ES,

  ES_US: {
    ...LOCALE_ES,
    formatDMY: false,
    formatMDY: true,
  },

  // Chinese
  // zh-CN
  CN: {
    formatYMD: true,
    longWeekdays: [
      "星期日",
      "星期一",
      "星期二",
      "星期三",
      "星期四",
      "星期五",
      "星期六",
    ],
    shortWeekdays: ["日", "一", "二", "三", "四", "五", "六"],
    longMonths: [
      "一月",
      "二月",
      "三月",
      "四月",
      "五月",
      "六月",
      "七月",
      "八月",
      "九月",
      "十月",
      "十一月",
      "十二月",
    ],
    shortMonths: [
      "一月",
      "二月",
      "三月",
      "四月",
      "五月",
      "六月",
      "七月",
      "八月",
      "九月",
      "十月",
      "十一月",
      "十二月",
    ], // can be shortened?
  },

  // Czech
  // cs-CZ
  CZ: {
    longWeekdays: [
      "neděle",
      "pondělí",
      "úterý",
      "středa",
      "čtvrtek",
      "pátek",
      "sobota",
    ],
    shortWeekdays: ["ne", "po", "út", "st", "čt", "pá", "so"],
    longMonths: [
      "leden",
      "únor",
      "březen",
      "duben",
      "květen",
      "červen",
      "červenec",
      "srpen",
      "září",
      "říjen",
      "listopad",
      "prosinec",
    ],
    shortMonths: [
      "led",
      "úno",
      "bře",
      "dub",
      "kvě",
      "čvn",
      "čvc",
      "srp",
      "zář",
      "říj",
      "lis",
      "pro",
    ],
  },

  // Danish
  DK: {
    longWeekdays: [
      "søndag",
      "mandag",
      "tirsdag",
      "onsdag",
      "torsdag",
      "fredag",
      "lørdag",
    ],
    shortWeekdays: ["søn.", "man.", "tirs.", "ons.", "tors.", "fre.", "lør."],
    longMonths: [
      "januar",
      "februar",
      "marts",
      "april",
      "maj",
      "juni",
      "juli",
      "august",
      "september",
      "oktober",
      "november",
      "december",
    ],
    shortMonths: [
      "jan.",
      "feb.",
      "mar.",
      "apr.",
      "maj",
      "jun.",
      "jul.",
      "aug.",
      "sep.",
      "okt.",
      "nov.",
      "dec.",
    ],
  },

  // Greek
  GR: {
    longWeekdays: [
      "Κυριακή",
      "Δευτέρα",
      "Τρίτη",
      "Τετάρτη",
      "Πέμπτη",
      "Παρασκευή",
      "Σάββατο",
    ],
    shortWeekdays: ["Κυρ", "Δευ", "Τρί", "Τετ", "Πέμ", "Παρ", "Σάβ"],
    longMonths: [
      "Ιανουαρίου",
      "Φεβρουαρίου",
      "Μαρτίου",
      "Απριλίου",
      "Μαΐου",
      "Ιουνίου",
      "Ιουλίου",
      "Αυγούστου",
      "Σεπτεμβρίου",
      "Οκτωβρίου",
      "Νοεμβρίου",
      "Δεκεμβρίου",
    ],
    shortMonths: [
      "Ιαν",
      "Φεβ",
      "Μαρ",
      "Απρ",
      "Μαΐ",
      "Ιουν",
      "Ιουλ",
      "Αυγ",
      "Σεπ",
      "Οκτ",
      "Νοε",
      "Δεκ",
    ],
  },

  // Dutch
  NL: {
    longWeekdays: [
      "zondag",
      "maandag",
      "dinsdag",
      "woensdag",
      "donderdag",
      "vrijdag",
      "zaterdag",
    ],
    shortWeekdays: ["zo", "ma", "di", "wo", "do", "vr", "za"],
    longMonths: [
      "januari",
      "februari",
      "maart",
      "april",
      "mei",
      "juni",
      "juli",
      "augustus",
      "september",
      "oktober",
      "november",
      "december",
    ],
    shortMonths: [
      "jan",
      "feb",
      "mrt",
      "apr",
      "mei",
      "jun",
      "jul",
      "aug",
      "sep",
      "okt",
      "nov",
      "dec",
    ],
  },

  // French
  FR: {
    longWeekdays: [
      "dimanche",
      "lundi",
      "mardi",
      "mercredi",
      "jeudi",
      "vendredi",
      "samedi",
    ],
    shortWeekdays: ["dim.", "lun.", "mar.", "mer.", "jeu.", "ven.", "sam."],
    longMonths: [
      "janvier",
      "février",
      "mars",
      "avril",
      "mai",
      "juin",
      "juillet",
      "août",
      "septembre",
      "octobre",
      "novembre",
      "décembre",
    ],
    shortMonths: [
      "janv.",
      "févr.",
      "mars",
      "avr.",
      "mai",
      "juin",
      "juil.",
      "août",
      "sept.",
      "oct.",
      "nov.",
      "déc.",
    ],
  },

  // Finnish
  FI: {
    longWeekdays: [
      "sunnuntai",
      "maanantai",
      "tiistai",
      "keskiviikko",
      "torstai",
      "perjantai",
      "lauantai",
    ],
    shortWeekdays: ["su", "ma", "ti", "ke", "to", "pe", "la"],
    longMonths: [
      "tammikuu",
      "helmikuu",
      "maaliskuu",
      "huhtikuu",
      "toukokuu",
      "kesäkuu",
      "heinäkuu",
      "elokuu",
      "syyskuu",
      "lokakuu",
      "marraskuu",
      "joulukuu",
    ],
    shortMonths: [
      "tammi",
      "helmi",
      "maalis",
      "huhti",
      "touko",
      "kesä",
      "heinä",
      "elo",
      "syys",
      "loka",
      "marras",
      "joulu",
    ],
  },

  // German
  DE: {
    longWeekdays: [
      "Sonntag",
      "Montag",
      "Dienstag",
      "Mittwoch",
      "Donnerstag",
      "Freitag",
      "Samstag",
    ],
    shortWeekdays: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
    longMonths: [
      "Januar",
      "Februar",
      "März",
      "April",
      "Mai",
      "Juni",
      "Juli",
      "August",
      "September",
      "Oktober",
      "November",
      "Dezember",
    ],
    shortMonths: [
      "Jan",
      "Feb",
      "Mär",
      "Apr",
      "Mai",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Okt",
      "Nov",
      "Dez",
    ],
  },

  // Hebrew
  // he-IL
  HE: {
    rtl: true,
    longWeekdays: [
      "יום ראשון",
      "יום שני",
      "יום שלישי",
      "יום רביעי",
      "יום חמישי",
      "יום שישי",
      "יום שבת",
    ],
    shortWeekdays: ["א׳", "ב׳", "ג׳", "ד׳", "ה׳", "ו׳", "שבת"],
    longMonths: [
      "ינואר",
      "פברואר",
      "מרץ",
      "אפריל",
      "מאי",
      "יוני",
      "יולי",
      "אוגוסט",
      "ספטמבר",
      "אוקטובר",
      "נובמבר",
      "דצמבר",
    ],
    shortMonths: [
      "ינו׳",
      "פבר׳",
      "מרץ",
      "אפר׳",
      "מאי",
      "יוני",
      "יולי",
      "אוג׳",
      "ספט׳",
      "אוק׳",
      "נוב׳",
      "דצמ׳",
    ],
  },

  // Italian
  // it-IT
  IT: {
    longWeekdays: [
      "domenica",
      "lunedì",
      "martedì",
      "mercoledì",
      "giovedì",
      "venerdì",
      "sabato",
    ],
    shortWeekdays: ["dom", "lun", "mar", "mer", "gio", "ven", "sab"],
    longMonths: [
      "gennaio",
      "febbraio",
      "marzo",
      "aprile",
      "maggio",
      "giugno",
      "luglio",
      "agosto",
      "settembre",
      "ottobre",
      "novembre",
      "dicembre",
    ],
    shortMonths: [
      "gen",
      "feb",
      "mar",
      "apr",
      "mag",
      "giu",
      "lug",
      "ago",
      "set",
      "ott",
      "nov",
      "dic",
    ],
  },

  // Indonesian
  ID: {
    longWeekdays: [
      "Minggu",
      "Senin",
      "Selasa",
      "Rabu",
      "Kamis",
      "Jumat",
      "Sabtu",
    ],
    shortWeekdays: ["Min", "Sen", "Sel", "Rab", "Kam", "Jum", "Sab"],
    longMonths: [
      "Januari",
      "Februari",
      "Maret",
      "April",
      "Mei",
      "Juni",
      "Juli",
      "Agustus",
      "September",
      "Oktober",
      "November",
      "Desember",
    ],
    shortMonths: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "Mei",
      "Jun",
      "Jul",
      "Agu",
      "Sep",
      "Okt",
      "Nov",
      "Des",
    ],
  },

  // Japanese
  // kanji vs hirigana?
  JP: {
    formatYMD: true,
    longWeekdays: [
      "にちようび",
      "げつようび",
      "かようび",
      "すいようび",
      "もくようび",
      "きんようび",
      "どようび",
    ],
    shortWeekdays: ["にち", "げつ", "か", "すい", "もく", "きん", "ど"], // guessed that we can shorten like this
    longMonths: [
      "一月",
      "二月",
      "三月",
      "四月",
      "五月",
      "六月",
      "七月",
      "八月",
      "九月",
      "十月",
      "十一月",
      "十二月",
    ],
    shortMonths: [
      "一月",
      "二月",
      "三月",
      "四月",
      "五月",
      "六月",
      "七月",
      "八月",
      "九月",
      "十月",
      "十一月",
      "十二月",
    ], // can be shortened?
  },

  // Korean
  KR: {
    formatYMD: true,
    longWeekdays: [
      "일요일",
      "월요일",
      "화요일",
      "수요일",
      "목요일",
      "금요일",
      "토요일",
    ],
    shortWeekdays: ["일", "월", "화", "수", "목", "금", "토"],
    longMonths: [
      "1월",
      "2월",
      "3월",
      "4월",
      "5월",
      "6월",
      "7월",
      "8월",
      "9월",
      "10월",
      "11월",
      "12월",
    ],
    shortMonths: [
      "1월",
      "2월",
      "3월",
      "4월",
      "5월",
      "6월",
      "7월",
      "8월",
      "9월",
      "10월",
      "11월",
      "12월",
    ],
  },

  // Norwegian
  NO: {
    longWeekdays: [
      "søndag",
      "mandag",
      "tirsdag",
      "onsdag",
      "torsdag",
      "fredag",
      "lørdag",
    ],
    shortWeekdays: ["søn.", "man.", "tir.", "ons.", "tor.", "fre.", "lør."],
    longMonths: [
      "januar",
      "februar",
      "mars",
      "april",
      "mai",
      "juni",
      "juli",
      "august",
      "september",
      "oktober",
      "november",
      "desember",
    ],
    shortMonths: [
      "jan",
      "feb",
      "mar",
      "apr",
      "mai",
      "jun",
      "jul",
      "aug",
      "sep",
      "okt",
      "nov",
      "des",
    ],
  },

  // Polish
  PL: {
    longWeekdays: [
      "niedziela",
      "poniedziałek",
      "wtorek",
      "środa",
      "czwartek",
      "piątek",
      "sobota",
    ],
    shortWeekdays: ["niedz.", "pon.", "wt.", "śr.", "czw.", "pt.", "sob."],
    longMonths: [
      "styczeń",
      "luty",
      "marzec",
      "kwiecień",
      "maj",
      "czerwiec",
      "lipiec",
      "sierpień",
      "wrzesień",
      "październik",
      "listopad",
      "grudzień",
    ],
    shortMonths: [
      "sty",
      "lut",
      "mar",
      "kwi",
      "maj",
      "cze",
      "lip",
      "sie",
      "wrz",
      "paź",
      "lis",
      "gru",
    ],
  },

  // Portuguese
  PT: {
    longWeekdays: [
      "domingo",
      "segunda-feira",
      "terça-feira",
      "quarta-feira",
      "quinta-feira",
      "sexta-feira",
      "sábado",
    ],
    shortWeekdays: ["dom", "seg", "ter", "qua", "qui", "sex", "sáb"],
    longMonths: [
      "janeiro",
      "fevereiro",
      "março",
      "abril",
      "maio",
      "junho",
      "julho",
      "agosto",
      "setembro",
      "outubro",
      "novembro",
      "dezembro",
    ],
    shortMonths: [
      "jan.",
      "fev.",
      "março",
      "abril",
      "maio",
      "junho",
      "julho",
      "agosto",
      "set.",
      "out.",
      "nov.",
      "dez.",
    ],
  },

  // Russian
  RU: {
    longWeekdays: [
      "Воскресенье",
      "понедельник",
      "вторник",
      "среда",
      "Четверг",
      "пятница",
      "суббота",
    ],
    shortWeekdays: ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
    longMonths: [
      "январь",
      "февраль",
      "март",
      "апрель",
      "май",
      "июнь",
      "июль",
      "август",
      "сентябрь",
      "октябрь",
      "ноябрь",
      "декабрь",
    ],
    shortMonths: [
      "Янв",
      "Фев",
      "Мар",
      "Апр",
      "Май",
      "Июн",
      "Июл",
      "Авг",
      "Сен",
      "Окт",
      "Ноя",
      "Дек",
    ],
  },

  // Swedish
  SE: {
    longWeekdays: [
      "söndag",
      "måndag",
      "tisdag",
      "onsdag",
      "torsdag",
      "fredag",
      "lördag",
    ],
    shortWeekdays: ["sön", "mån", "tis", "ons", "tors", "fre", "lör"],
    longMonths: [
      "januari",
      "februari",
      "mars",
      "april",
      "maj",
      "juni",
      "juli",
      "augusti",
      "september",
      "oktober",
      "november",
      "december",
    ],
    shortMonths: [
      "jan.",
      "feb.",
      "mars",
      "apr.",
      "maj",
      "juni",
      "juli",
      "aug.",
      "sep.",
      "okt.",
      "nov.",
      "dec.",
    ],
  },

  // Turkish
  // tr-TR
  TR: {
    longWeekdays: [
      "Pazar",
      "Pazartesi",
      "Salı",
      "Çarşamba",
      "Perşembe",
      "Cuma",
      "Cumartesi",
    ],
    shortWeekdays: ["Paz", "Pzt", "Sal", "Çar", "Per", "Cum", "Cmt"],
    longMonths: [
      "Ocak",
      "Şubat",
      "Mart",
      "Nisan",
      "Mayıs",
      "Haziran",
      "Temmuz",
      "Ağustos",
      "Eylül",
      "Ekim",
      "Kasım",
      "Aralık",
    ],
    shortMonths: [
      "Oca",
      "Şub",
      "Mar",
      "Nis",
      "May",
      "Haz",
      "Tem",
      "Ağu",
      "Eyl",
      "Eki",
      "Kas",
      "Ara",
    ],
  },

  // Ukrainian
  // uk-UA
  UA: {
    longWeekdays: [
      "Неділя",
      "Понеділок",
      "Вівторок",
      "Середа",
      "Четвер",
      "П'ятниця",
      "Субота",
    ],
    shortWeekdays: ["Ндл", "Пнд", "Втр", "Срд", "Чтв", "Птн", "Сбт"],
    longMonths: [
      "Січень",
      "Лютий",
      "Березень",
      "Квітень",
      "Травень",
      "Червень",
      "Липень",
      "Серпень",
      "Вересень",
      "Жовтень",
      "Листопад",
      "Грудень",
    ],
    shortMonths: [
      "Сiч",
      "Лют",
      "Бер",
      "Квiт",
      "Трав",
      "Черв",
      "Лип",
      "Серп",
      "Вер",
      "Жовт",
      "Лист",
      "Груд",
    ],
  },

  // Persian / Farsi (fa)
  IR: {
    rtl: true,
    longWeekdays: [
      "یکشنبه",
      "دوشنبه",
      "سه‌شنبه",
      "چهارشنبه",
      "پنجشنبه",
      "جمعه",
      "شنبه",
    ],
    shortWeekdays: [
      "یکشنبه",
      "دوشنبه",
      "سه‌شنبه",
      "چهارشنبه",
      "پنجشنبه",
      "جمعه",
      "شنبه",
    ],
    longMonths: [
      "دی",
      "بهمن",
      "اسفند",
      "فروردین",
      "اردیبهشت",
      "خرداد",
      "تیر",
      "مرداد",
      "شهریور",
      "مهر",
      "آبان",
      "آذر",
    ],
    shortMonths: [
      "دی",
      "بهمن",
      "اسفند",
      "فروردین",
      "اردیبهشت",
      "خرداد",
      "تیر",
      "مرداد",
      "شهریور",
      "مهر",
      "آبان",
      "آذر",
    ],
  },

  // Arabic - Modern Standard (arb)
  AR: {
    rtl: true,
    longWeekdays: [
      "الأحد",
      "الاثنين",
      "الثلاثاء",
      "الأربعاء",
      "الخميس",
      "الجمعة",
      "السبت",
    ],
    shortWeekdays: [
      "الأحد",
      "الاثنين",
      "الثلاثاء",
      "الأربعاء",
      "الخميس",
      "الجمعة",
      "السبت",
    ],
    longMonths: [
      "يناير",
      "فبراير",
      "مارس",
      "أبريل",
      "مايو",
      "يونيو",
      "يوليو",
      "أغسطس",
      "سبتمبر",
      "أكتوبر",
      "نوفمبر",
      "ديسمبر",
    ],
    shortMonths: [
      "يناير",
      "فبراير",
      "مارس",
      "أبريل",
      "مايو",
      "يونيو",
      "يوليو",
      "أغسطس",
      "سبتمبر",
      "أكتوبر",
      "نوفمبر",
      "ديسمبر",
    ],
  },

  // Swahili (sw)
  SW: {
    longWeekdays: [
      "Jumapili",
      "Jumatatu",
      "Jumanne",
      "Jumatano",
      "Alhamisi",
      "Ijumaa",
      "Jumamosi",
    ],
    shortWeekdays: [
      "Jumapili",
      "Jumatatu",
      "Jumanne",
      "Jumatano",
      "Alhamisi",
      "Ijumaa",
      "Jumamosi",
    ],
    longMonths: [
      "Januari",
      "Februari",
      "Machi",
      "Aprili",
      "Mei",
      "Juni",
      "Julai",
      "Agosti",
      "Septemba",
      "Oktoba",
      "Novemba",
      "Desemba",
    ],
    shortMonths: [
      "Jan",
      "Feb",
      "Mac",
      "Apr",
      "Mei",
      "Jun",
      "Jul",
      "Ago",
      "Sep",
      "Okt",
      "Nov",
      "Des",
    ],
  },

  // estonian
  [DATEFORMAT_EE]: {
    code: "et",
    longWeekdays: [
      "pühapäev",
      "esmaspäev",
      "teisipäev",
      "kolmapäev",
      "neljapäev",
      "reede",
      "laupäev",
    ],
    shortWeekdays: ["P", "E", "T", "K", "N", "R", "L"],
    longMonths: [
      "jaanuar",
      "veebruar",
      "märts",
      "aprill",
      "mai",
      "juuni",
      "juuli",
      "august",
      "september",
      "oktoober",
      "november",
      "detsember",
    ],
    shortMonths: [
      "jaanuar",
      "veebruar",
      "märts",
      "aprill",
      "mai",
      "juuni",
      "juuli",
      "august",
      "september",
      "oktoober",
      "november",
      "detsember",
    ],
  },

  // Hungarian
  [DATEFORMAT_HU]: {
    formatYMD: true,
    code: "hu",
    longWeekdays: [
      "vasárnap",
      "hétfő",
      "kedd",
      "szerda",
      "csütörtök",
      "péntek",
      "szombat",
    ],
    shortWeekdays: ["V", "H", "K", "Sze", "Cs", "P", "Szo"],
    longMonths: [
      "január",
      "február",
      "március",
      "április",
      "május",
      "június",
      "július",
      "augusztus",
      "szeptember",
      "október",
      "november",
      "december",
    ],
    shortMonths: [
      "jan.",
      "febr.",
      "márc.",
      "ápr.",
      "máj.",
      "jún.",
      "júl.",
      "aug.",
      "szept.",
      "okt.",
      "nov.",
      "dec.",
    ],
  },

  // Luxembourgish
  [DATEFORMAT_LU]: {
    code: "lb",
    longWeekdays: [
      "Sonndeg",
      "Méindeg",
      "Dënschdeg",
      "Mëttwoch",
      "Donneschdeg",
      "Freideg",
      "Samschdeg",
    ],
    shortWeekdays: ["Son", "Méi", "Dën", "Mët", "Don", "Fre", "Sam"],
    longMonths: [
      "Januar",
      "Februar",
      "Mäerz",
      "Abrëll",
      "Mee",
      "Juni",
      "Juli",
      "August",
      "September",
      "Oktober",
      "November",
      "Dezember",
    ],
    shortMonths: [
      "Jan",
      "Feb",
      "Mäe",
      "Abr",
      "Mee",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Okt",
      "Nov",
      "Dez",
    ],
  },

  // irish
  IE: {
    code: "ga",
    longWeekdays: [
      "Luan",
      "Mháirt",
      "Chéadaoin",
      "Déardaoin",
      "Aoine",
      "Satharn",
      "Domhnach",
    ],
    // guessed by Ben:
    shortWeekdays: ["Lua", "Mhá", "Ché", "Déa", "Aoi", "Sat", "Dom"],
    longMonths: [
      "Eanáir",
      "Feabhra",
      "Márta",
      "Aibreán",
      "Bealtaine",
      "Meitheamh",
      "Iúil",
      "Lúnasa",
      "Meán Fómhair",
      "Deireadh Fomhair",
      "na Samhna",
      "na Nollag",
    ],
    // guessed by Ben:
    shortMonths: [
      "Ean",
      "Fea",
      "Már",
      "Aib",
      "Bea",
      "Mei",
      "Iúi",
      "Lún",
      "Meá",
      "Dei",
      "Sam",
      "Nol",
    ],
  },

  // Croatian
  HR: {
    code: "hr",
    longWeekdays: [
      "nedjelja",
      "ponedjeljak",
      "utorak",
      "srijeda",
      "četvrtak",
      "petak",
      "subota",
    ],
    shortWeekdays: ["ned", "pon", "uto", "sri", "čet", "pet", "sub"],
    longMonths: [
      "siječanj",
      "veljača",
      "ožujak",
      "travanj",
      "svibanj",
      "lipanj",
      "srpanj",
      "kolovoz",
      "rujan",
      "listopad",
      "studeni",
      "prosinac",
    ],
    shortMonths: [
      "sij",
      "velj",
      "ožu",
      "tra",
      "svi",
      "lip",
      "srp",
      "kol",
      "ruj",
      "lis",
      "stu",
      "pro",
    ],
  },

  // Latvian
  LV: {
    code: "lv",
    longWeekdays: [
      "Svētdiena",
      "Pirmdiena",
      "Otrdiena",
      "Trešdiena",
      "Ceturtdiena",
      "Piektdiena",
      "Sestdiena",
    ],
    shortWeekdays: [
      "Svētd.",
      "Pirmd.",
      "Otrd.",
      "Trešd.",
      "Ceturtd.",
      "Piektd.",
      "Sestd.",
    ],
    longMonths: [
      "janvāris",
      "februāris",
      "marts",
      "aprīlis",
      "maijs",
      "jūnijs",
      "jūlijs",
      "augusts",
      "septembris",
      "oktobris",
      "novembris",
      "decembris",
    ],
    shortMonths: [
      "janv.",
      "febr.",
      "marts",
      "apr.",
      "maijs",
      "jūn.",
      "jūl.",
      "aug.",
      "sept.",
      "okt.",
      "nov.",
      "dec.",
    ],
  },

  LI: {
    code: "lt",
    longWeekdays: [
      "sekmadienis",
      "pirmadienis",
      "antradienis",
      "trečiadienis",
      "ketvirtadienis",
      "penktadienis",
      "šeštadienis",
    ],
    shortWeekdays: ["sk", "pr", "an", "tr", "kt", "pn", "št"],
    longMonths: [
      "sausis",
      "vasaris",
      "kovas",
      "balandis",
      "gegužė",
      "birželis",
      "liepa",
      "rugpjūtis",
      "rugsėjis",
      "spalis",
      "lapkritis",
      "gruodis",
    ],
    shortMonths: [
      "01",
      "02",
      "03",
      "04",
      "05",
      "06",
      "07",
      "08",
      "09",
      "10",
      "11",
      "12",
    ],
  },

  RO: {
    code: "ro",
    longWeekdays: [
      "duminică",
      "luni",
      "marți",
      "miercuri",
      "joi",
      "vineri",
      "sâmbătă",
    ],
    shortWeekdays: ["dum.", "lun.", "mar.", "mie.", "joi", "vin.", "sâm."],
    longMonths: [
      "ianuarie",
      "februarie",
      "martie",
      "aprilie",
      "mai",
      "iunie",
      "iulie",
      "august",
      "septembrie",
      "octombrie",
      "noiembrie",
      "decembrie",
    ],
    shortMonths: [
      "ian.",
      "feb.",
      "mar.",
      "apr.",
      "mai",
      "iun.",
      "iul.",
      "aug.",
      "sept.",
      "oct.",
      "nov.",
      "dec.",
    ],
  },

  SK: {
    code: "sk",
    longWeekdays: [
      "nedeľa",
      "pondelok",
      "utorok",
      "streda",
      "štvrtok",
      "piatok",
      "sobota",
    ],
    shortWeekdays: ["ne", "po", "ut", "st", "št", "pi", "so"],
    longMonths: [
      "január",
      "február",
      "marec",
      "apríl",
      "máj",
      "jún",
      "júl",
      "august",
      "september",
      "október",
      "november",
      "december",
    ],
    shortMonths: [
      "jan",
      "feb",
      "mar",
      "apr",
      "máj",
      "jún",
      "júl",
      "aug",
      "sep",
      "okt",
      "nov",
      "dec",
    ],
  },

  SI: {
    code: "sl",
    longWeekdays: [
      "nedelja",
      "ponedeljek",
      "torek",
      "sreda",
      "četrtek",
      "petek",
      "sobota",
    ],
    shortWeekdays: ["ned.", "pon.", "tor.", "sre.", "čet.", "pet.", "sob."],
    longMonths: [
      "januar",
      "februar",
      "marec",
      "april",
      "maj",
      "junij",
      "julij",
      "avgust",
      "september",
      "oktober",
      "november",
      "december",
    ],
    shortMonths: [
      "jan.",
      "feb.",
      "mar.",
      "apr.",
      "maj",
      "jun.",
      "jul.",
      "avg.",
      "sep.",
      "okt.",
      "nov.",
      "dec.",
    ],
  },

  BG: {
    code: "bg",
    longWeekdays: [
      "неделя",
      "понеделник",
      "вторник",
      "сряда",
      "четвъртък",
      "петък",
      "събота",
    ],
    shortWeekdays: ["нд", "пн", "вт", "ср", "чт", "пт", "сб"],
    longMonths: [
      "януари",
      "февруари",
      "март",
      "април",
      "май",
      "юни",
      "юли",
      "август",
      "септември",
      "октомври",
      "ноември",
      "декември",
    ],
    shortMonths: [
      "01",
      "02",
      "03",
      "04",
      "05",
      "06",
      "07",
      "08",
      "09",
      "10",
      "11",
      "12",
    ],
  },

  // https://www.localeplanet.com/icu/mt/index.html
  // Maltese
  MT: {
    code: "mt",
    longWeekdays: [
      "Il-Ħadd",
      "It-Tnejn",
      "It-Tlieta",
      "L-Erbgħa",
      "Il-Ħamis",
      "Il-Ġimgħa",
      "Is-Sibt",
    ],
    shortWeekdays: ["Ħad", "Tne", "Tli", "Erb", "Ħam", "Ġim", "Sib"],
    longMonths: [
      "Jannar",
      "Frar",
      "Marzu",
      "April",
      "Mejju",
      "Ġunju",
      "Lulju",
      "Awwissu",
      "Settembru",
      "Ottubru",
      "Novembru",
      "Diċembru",
    ],
    shortMonths: [
      "Jan",
      "Fra",
      "Mar",
      "Apr",
      "Mej",
      "Ġun",
      "Lul",
      "Aww",
      "Set",
      "Ott",
      "Nov",
      "Diċ",
    ],
  },

  // Vietnamese
  VN: {
    code: "vi",
    longWeekdays: [
      "Chủ Nhật",
      "Thứ Hai",
      "Thứ Ba",
      "Thứ Tư",
      "Thứ Năm",
      "Thứ Sáu",
      "Thứ Bảy",
    ],
    shortWeekdays: ["CN", "Th 2", "Th 3", "Th 4", "Th 5", "Th 6", "Th 7"],
    longMonths: [
      "Tháng 1",
      "Tháng 2",
      "Tháng 3",
      "Tháng 4",
      "Tháng 5",
      "Tháng 6",
      "Tháng 7",
      "Tháng 8",
      "Tháng 9",
      "Tháng 10",
      "Tháng 11",
      "Tháng 12",
    ],
    shortMonths: [
      "Thg 1",
      "Thg 2",
      "Thg 3",
      "Thg 4",
      "Thg 5",
      "Thg 6",
      "Thg 7",
      "Thg 8",
      "Thg 9",
      "Thg 10",
      "Thg 11",
      "Thg 12",
    ],
  },

  // Bengali (Bangladesh)
  [DATEFORMAT_BD]: {
    code: "bn",
    longWeekdays: [
      "রবিবার",
      "সোমবার",
      "মঙ্গলবার",
      "বুধবার",
      "বৃহস্পতিবার",
      "শুক্রবার",
      "শনিবার",
    ],
    shortWeekdays: ["রবি", "সোম", "মঙ্গল", "বুধ", "বৃহস্পতি", "শুক্র", "শনি"],
    longMonths: [
      "জানুয়ারী",
      "ফেব্রুয়ারী",
      "মার্চ",
      "এপ্রিল",
      "মে",
      "জুন",
      "জুলাই",
      "আগস্ট",
      "সেপ্টেম্বর",
      "অক্টোবর",
      "নভেম্বর",
      "ডিসেম্বর",
    ],
    shortMonths: [
      "জানু",
      "ফেব",
      "মার্চ",
      "এপ্রিল",
      "মে",
      "জুন",
      "জুলাই",
      "আগস্ট",
      "সেপ্টেম্বর",
      "অক্টোবর",
      "নভেম্বর",
      "ডিসেম্বর",
    ],
  },

  // Hindi (India)
  [DATEFORMAT_IN]: {
    code: "hi",
    longWeekdays: [
      "रविवार",
      "सोमवार",
      "मंगलवार",
      "बुधवार",
      "गुरुवार",
      "शुक्रवार",
      "शनिवार",
    ],
    shortWeekdays: ["रवि", "सोम", "मंगल", "बुध", "गुरु", "शुक्र", "शनि"],
    longMonths: [
      "जनवरी",
      "फ़रवरी",
      "मार्च",
      "अप्रैल",
      "मई",
      "जून",
      "जुलाई",
      "अगस्त",
      "सितंबर",
      "अक्तूबर",
      "नवंबर",
      "दिसंबर",
    ],
    shortMonths: [
      "जन॰",
      "फ़र॰",
      "मार्च",
      "अप्रैल",
      "मई",
      "जून",
      "जुल॰",
      "अग॰",
      "सित॰",
      "अक्तू॰",
      "नव॰",
      "दिस॰",
    ],
  },

  // Urdu (Pakistan)
  [DATEFORMAT_PK]: {
    rtl: true,
    code: "ur",
    longWeekdays: ["اتوار", "پیر", "منگل", "بدھ", "جمعرات", "جمعہ", "ہفتہ"],
    shortWeekdays: ["اتوار", "پیر", "منگل", "بدھ", "جمعرات", "جمعہ", "ہفتہ"],
    longMonths: [
      "جنوری",
      "فروری",
      "مارچ",
      "اپریل",
      "مئی",
      "جون",
      "جولائی",
      "اگست",
      "ستمبر",
      "اکتوبر",
      "نومبر",
      "دسمبر",
    ],
    shortMonths: [
      "جنوری",
      "فروری",
      "مارچ",
      "اپریل",
      "مئی",
      "جون",
      "جولائی",
      "اگست",
      "ستمبر",
      "اکتوبر",
      "نومبر",
      "دسمبر",
    ],
  },

  // Icelandic
  [DATEFORMAT_IS]: {
    code: "is",
    longWeekdays: [
      "sunnudagur",
      "mánudagur",
      "þriðjudagur",
      "miðvikudagur",
      "fimmtudagur",
      "föstudagur",
      "laugardagur",
    ],
    shortWeekdays: ["sun.", "mán.", "þri.", "mið.", "fim.", "fös.", "lau."],
    longMonths: [
      "janúar",
      "febrúar",
      "mars",
      "apríl",
      "maí",
      "júní",
      "júlí",
      "ágúst",
      "september",
      "október",
      "nóvember",
      "desember",
    ],
    shortMonths: [
      "jan.",
      "feb.",
      "mar.",
      "apr.",
      "maí",
      "jún.",
      "júl.",
      "ágú.",
      "sep.",
      "okt.",
      "nóv.",
      "des.",
    ],
  },

  // Welsh
  [DATEFORMAT_WALES]: {
    code: "cym",
    longWeekdays: [
      "Dydd Sul",
      "Dydd Llun",
      "Dydd Mawrth",
      "Dydd Mercher",
      "Dydd Iau",
      "Dydd Gwener",
      "Dydd Sadwrn",
    ],
    shortWeekdays: ["Sul", "Llun", "Maw", "Mer", "Iau", "Gwe", "Sad"],
    longMonths: [
      "Ionawr",
      "Chwefror",
      "Mawrth",
      "Ebrill",
      "Mai",
      "Mehefin",
      "Gorffennaf",
      "Awst",
      "Medi",
      "Hydref",
      "Tachwedd",
      "Rhagfyr",
    ],
    shortMonths: [
      "Ion",
      "Chw",
      "Maw",
      "Ebr",
      "Mai",
      "Meh",
      "Gor",
      "Awst",
      "Medi",
      "Hyd",
      "Tach",
      "Rhag",
    ],
  },

  // Scots Gaeilic
  [DATEFORMAT_SCOTLAND]: {
    code: "gd",
    longWeekdays: [
      "DiDòmhnaich",
      "DiLuain",
      "DiMàirt",
      "DiCiadain",
      "DiarDaoin",
      "DihAoine",
      "DiSathairne",
    ],
    shortWeekdays: ["DiD", "DiL", "DiM", "DiC", "Dia", "Dih", "DiS"],
    longMonths: [
      "Am Faoilleach",
      "An Gearran",
      "Am Màrt",
      "An Giblean",
      "An Cèitean",
      "An t-Ògmhios",
      "An t-Iuchar",
      "An Lùnastal",
      "An t-Sultain",
      "An Dàmhair",
      "An t-Samhain",
      "An Dùbhlachd",
    ],
    shortMonths: [
      "Faoi",
      "Gearr",
      "Màrt",
      "Gibl",
      "Cèit",
      "Ògmh",
      "Iuch",
      "Lùna",
      "Sult",
      "Dàmh",
      "Samh",
      "Dùbh",
    ],
  },

  [DATEFORMAT_IM]: {
    longWeekdays: [
      "Jedoonee",
      "Jelhune",
      "Jemayrt",
      "Jecrean",
      "Jerdein",
      "Jeheiney",
      "Jesarn",
    ],
    shortWeekdays: ["Jed", "Jel", "Jem", "Jec", "Jer", "Jeh", "Jes"],
    longMonths: [
      "Jerrey-geuree",
      "Toshiaght-arree",
      "Mayrnt",
      "Averil",
      "Boaldyn",
      "Mean-souree",
      "Jerrey-souree",
      "Luanistyn",
      "Mean-fouyir",
      "Jerrey-fouyir",
      "Mee Houney",
      "Mee ny Nollick",
    ],
    shortMonths: [
      "J-guer",
      "T-arree",
      "Mayrnt",
      "Avrril",
      "Boaldyn",
      "M-souree",
      "J-souree",
      "Luanistyn",
      "M-fouyir",
      "J-fouyir",
      "M Houney",
      "M Nollick",
    ],
  },

  [DATEFORMAT_MY]: {
    code: "ms",
    longWeekdays: [
      "Ahad",
      "Isnin",
      "Selasa",
      "Rabu",
      "Khamis",
      "Jumaat",
      "Sabtu",
    ],
    shortWeekdays: ["Ahd", "Isn", "Sel", "Rab", "Kha", "Jum", "Sab"],
    longMonths: [
      "Januari",
      "Februari",
      "Mac",
      "April",
      "Mei",
      "Jun",
      "Julai",
      "Ogos",
      "September",
      "Oktober",
      "November",
      "Disember",
    ],
    shortMonths: [
      "Jan",
      "Feb",
      "Mac",
      "Apr",
      "Mei",
      "Jun",
      "Jul",
      "Ogo",
      "Sep",
      "Okt",
      "Nov",
      "Dis",
    ],
  },

  [DATEFORMAT_FO]: {
    code: "fo",
    longWeekdays: [
      "sunnudagur",
      "mánadagur",
      "týsdagur",
      "mikudagur",
      "hósdagur",
      "fríggjadagur",
      "leygardagur",
    ],
    shortWeekdays: ["sun", "mán", "týs", "mik", "hós", "frí", "ley"],
    longMonths: [
      "januar",
      "februar",
      "mars",
      "apríl",
      "mai",
      "juni",
      "juli",
      "august",
      "september",
      "oktober",
      "november",
      "desember",
    ],
    shortMonths: [
      "jan",
      "feb",
      "mar",
      "apr",
      "mai",
      "jun",
      "jul",
      "aug",
      "sep",
      "okt",
      "nov",
      "des",
    ],
  },

  [DATEFORMAT_MARATHI]: {
    code: "mr",
    longWeekdays: [
      "रविवार",
      "सोमवार",
      "मंगळवार",
      "बुधवार",
      "गुरुवार",
      "शुक्रवार",
      "शनिवार",
    ],
    shortWeekdays: ["रवि", "सोम", "मंगळ", "बुध", "गुरु", "शुक्र", "शनि"],
    longMonths: [
      "जानेवारी",
      "फेब्रुवारी",
      "मार्च",
      "एप्रिल",
      "मे",
      "जून",
      "जुलै",
      "ऑगस्ट",
      "सप्टेंबर",
      "ऑक्टोबर",
      "नोव्हेंबर",
      "डिसेंबर",
    ],
    shortMonths: [
      "जाने",
      "फेब्रु",
      "मार्च",
      "एप्रि",
      "मे",
      "जून",
      "जुलै",
      "ऑग",
      "सप्टें",
      "ऑक्टो",
      "नोव्हें",
      "डिसें",
    ],
  },

  [DATEFORMAT_TELUGU]: {
    code: "te",
    longWeekdays: [
      "ఆదివారం",
      "సోమవారం",
      "మంగళవారం",
      "బుధవారం",
      "గురువారం",
      "శుక్రవారం",
      "శనివారం",
    ],
    shortWeekdays: ["ఆది", "సోమ", "మంగళ", "బుధ", "గురు", "శుక్ర", "శని"],
    longMonths: [
      "జనవరి",
      "ఫిబ్రవరి",
      "మార్చి",
      "ఏప్రిల్",
      "మే",
      "జూన్",
      "జులై",
      "ఆగస్టు",
      "సెప్టెంబర్",
      "అక్టోబర్",
      "నవంబర్",
      "డిసెంబర్",
    ],
    shortMonths: [
      "జన",
      "ఫిబ్ర",
      "మార్చి",
      "ఏప్రి",
      "మే",
      "జూన్",
      "జులై",
      "ఆగ",
      "సెప్టెం",
      "అక్టో",
      "నవం",
      "డిసెం",
    ],
  },

  [DATEFORMAT_GUJARATI]: {
    code: "gu",
    longWeekdays: [
      "રવિવાર",
      "સોમવાર",
      "મંગળવાર",
      "બુધવાર",
      "ગુરુવાર",
      "શુક્રવાર",
      "શનિવાર",
    ],
    shortWeekdays: ["રવિ", "સોમ", "મંગળ", "બુધ", "ગુરુ", "શુક્ર", "શનિ"],
    longMonths: [
      "જાન્યુઆરી",
      "ફેબ્રુઆરી",
      "માર્ચ",
      "એપ્રિલ",
      "મે",
      "જૂન",
      "જુલાઈ",
      "ઑગસ્ટ",
      "સપ્ટેમ્બર",
      "ઑક્ટોબર",
      "નવેમ્બર",
      "ડિસેમ્બર",
    ],
    shortMonths: [
      "જાન્યુ",
      "ફેબ્રુ",
      "માર્ચ",
      "એપ્રિલ",
      "મે",
      "જૂન",
      "જુલાઈ",
      "ઑગસ્ટ",
      "સપ્ટે",
      "ઑક્ટો",
      "નવે",
      "ડિસે",
    ],
  },

  [DATEFORMAT_PUNJABI]: {
    code: "pa",
    longWeekdays: [
      "ਐਤਵਾਰ",
      "ਸੋਮਵਾਰ",
      "ਮੰਗਲਵਾਰ",
      "ਬੁੱਧਵਾਰ",
      "ਵੀਰਵਾਰ",
      "ਸ਼ੁੱਕਰਵਾਰ",
      "ਸ਼ਨਿੱਚਰਵਾਰ",
    ],
    shortWeekdays: ["ਐਤ", "ਸੋਮ", "ਮੰਗਲ", "ਬੁੱਧ", "ਵੀਰ", "ਸ਼ੁੱਕਰ", "ਸ਼ਨਿੱਚਰ"],
    longMonths: [
      "ਜਨਵਰੀ",
      "ਫ਼ਰਵਰੀ",
      "ਮਾਰਚ",
      "ਅਪ੍ਰੈਲ",
      "ਮਈ",
      "ਜੂਨ",
      "ਜੁਲਾਈ",
      "ਅਗਸਤ",
      "ਸਤੰਬਰ",
      "ਅਕਤੂਬਰ",
      "ਨਵੰਬਰ",
      "ਦਸੰਬਰ",
    ],
    shortMonths: [
      "ਜਨ",
      "ਫ਼ਰ",
      "ਮਾਰਚ",
      "ਅਪ੍ਰੈ",
      "ਮਈ",
      "ਜੂਨ",
      "ਜੁਲਾ",
      "ਅਗ",
      "ਸਤੰ",
      "ਅਕਤੂ",
      "ਨਵੰ",
      "ਦਸੰ",
    ],
  },

  [DATEFORMAT_JAVANESE]: {
    code: "jv",
    longWeekdays: [
      "Ahad",
      "Senin",
      "Selasa",
      "Rabu",
      "Kamis",
      "Jumat",
      "Sabtu",
    ],
    shortWeekdays: ["Ahad", "Sen", "Sel", "Rab", "Kam", "Jum", "Sab"],
    longMonths: [
      "Januari",
      "Februari",
      "Maret",
      "April",
      "Mei",
      "Juni",
      "Juli",
      "Agustus",
      "September",
      "Oktober",
      "November",
      "Desember",
    ],
    shortMonths: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "Mei",
      "Jun",
      "Jul",
      "Agt",
      "Sep",
      "Okt",
      "Nov",
      "Des",
    ],
  },

  [DATEFORMAT_TAMIL]: {
    code: "ta",
    longWeekdays: [
      "ஞாயிறு",
      "திங்கள்",
      "செவ்வாய்",
      "புதன்",
      "வியாழன்",
      "வெள்ளி",
      "சனி",
    ],
    shortWeekdays: ["ஞாயி.", "திங்.", "செவ்.", "புத.", "வியா.", "வெள்.", "சனி"],
    longMonths: [
      "ஜனவரி",
      "பிப்ரவரி",
      "மார்ச்",
      "ஏப்ரல்",
      "மே",
      "ஜூன்",
      "ஜூலை",
      "ஆகஸ்ட்",
      "செப்டம்பர்",
      "அக்டோபர்",
      "நவம்பர்",
      "டிசம்பர்",
    ],
    shortMonths: [
      "ஜன.",
      "பிப்.",
      "மார்.",
      "ஏப்.",
      "மே",
      "ஜூன்",
      "ஜூலை",
      "ஆக.",
      "செப்.",
      "அக்.",
      "நவ.",
      "டிச.",
    ],
  },

  [DATEFORMAT_MM]: {
    code: "my",
    longWeekdays: [
      "တနင်္ဂနွေ",
      "တနင်္လာ",
      "အင်္ဂါ",
      "ဗုဒ္ဓဟူး",
      "ကြာသပတေး",
      "သောကြာ",
      "စနေ",
    ],
    shortWeekdays: [
      "တနင်္ဂ  နွေ",
      "တနင်္လာ",
      "အင်္ဂါ",
      "ဗုဒ္ဓဟူး",
      "ကြာသပတေး",
      "သောကြာ",
      "စနေ",
    ],
    longMonths: [
      "ဇန်နဝါရီ",
      "ဖေဖော်ဝါရီ",
      "မတ်",
      "ဧပြီ",
      "မေ",
      "ဇွန်",
      "ဇူလိုင်",
      "ဩဂုတ်",
      "စက်တင်ဘာ",
      "အောက်တိုဘာ",
      "နိုဝင်ဘာ",
      "ဒီဇင်ဘာ",
    ],
    shortMonths: [
      "ဇန်",
      "ဖေ",
      "မတ်",
      "ဧ",
      "မေ",
      "ဇွန်",
      "ဇူ",
      "ဩ",
      "စက်",
      "အောက်",
      "နို",
      "ဒီ",
    ],
  },

  [DATEFORMAT_PH]: {
    formatDMY: true,
    formatMDY: true,
    code: "fil",
    longWeekdays: [
      "Linggo",
      "Lunes",
      "Martes",
      "Miyerkules",
      "Huwebes",
      "Biyernes",
      "Sabado",
    ],
    shortWeekdays: ["Lin", "Lun", "Mar", "Miy", "Huw", "Biy", "Sab"],
    longMonths: [
      "Enero",
      "Pebrero",
      "Marso",
      "Abril",
      "Mayo",
      "Hunyo",
      "Hulyo",
      "Agosto",
      "Setyembre",
      "Oktubre",
      "Nobyembre",
      "Disyembre",
    ],
    shortMonths: [
      "Ene",
      "Peb",
      "Mar",
      "Abr",
      "May",
      "Hun",
      "Hul",
      "Ago",
      "Set",
      "Okt",
      "Nob",
      "Dis",
    ],
  },

  [DATEFORMAT_TH]: {
    code: "th",
    longWeekdays: [
      "วันอาทิตย์",
      "วันจันทร์",
      "วันอังคาร",
      "วันพุธ",
      "วันพฤหัสบดี",
      "วันศุกร์",
      "วันเสาร์",
    ],
    shortWeekdays: ["อา.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."],
    longMonths: [
      "มกราคม",
      "กุมภาพันธ์",
      "มีนาคม",
      "เมษายน",
      "พฤษภาคม",
      "มิถุนายน",
      "กรกฎาคม",
      "สิงหาคม",
      "กันยายน",
      "ตุลาคม",
      "พฤศจิกายน",
      "ธันวาคม",
    ],
    shortMonths: [
      "ม.ค.",
      "ก.พ.",
      "มี.ค.",
      "เม.ย.",
      "พ.ค.",
      "มิ.ย.",
      "ก.ค.",
      "ส.ค.",
      "ก.ย.",
      "ต.ค.",
      "พ.ย.",
      "ธ.ค.",
    ],
  },

  [DATEFORMAT_GL]: {
    code: "kl",
    longWeekdays: [
      "sapaat",
      "ataasinngorneq",
      "marlunngorneq",
      "pingasunngorneq",
      "sisamanngorneq",
      "tallimanngorneq",
      "arfininngorneq",
    ],
    shortWeekdays: ["sap", "ata", "mar", "pin", "sis", "tal", "arf"],
    longMonths: [
      "januaari",
      "februaari",
      "marsi",
      "apriili",
      "maaji",
      "juuni",
      "juuli",
      "aggusti",
      "septembari",
      "oktobari",
      "novembari",
      "decembari",
    ],
    shortMonths: [
      "jan",
      "febr",
      "mar",
      "apr",
      "maj",
      "jun",
      "jul",
      "aug",
      "sept",
      "okt",
      "nov",
      "dec",
    ],
  },

  [DATEFORMAT_MAORI1]: {
    code: "mi",
    longWeekdays: [
      "Rātapu",
      "Mane",
      "Tūrei",
      "Wenerei",
      "Tāite",
      "Paraire",
      "Rāhoroi",
    ],
    shortWeekdays: ["Rāt", "Mane", "Tūr", "Wene", "Tāit", "Par", "Rāh"],
    longMonths: [
      "Hānuere",
      "Pēpuere",
      "Māehe",
      "Āpereira",
      "Mei",
      "Hune",
      "Hūrae",
      "Ākuhata",
      "Hepetema",
      "Oketopa",
      "Noema",
      "Tīhema",
    ],
    shortMonths: [
      "Hān",
      "Pēp",
      "Māe",
      "Āpe",
      "Mei",
      "Hune",
      "Hūr",
      "Āku",
      "Hep",
      "Oke",
      "Noem",
      "Tīhe",
    ],
  },

  [DATEFORMAT_MAORI2]: {
    code: "mi",
    longWeekdays: [
      "Rātapu",
      "Rāhina",
      "Rātū",
      "Rāapa",
      "Rāpare",
      "Rāmere",
      "Rāhoroi",
    ],
    shortWeekdays: ["Rāta", "Rāhi", "Rātū", "Rāapa", "Rāpa", "Rāme", "Rāho"],
    longMonths: [
      "Kohitātea",
      "Hui-tanguru",
      "Poutū-te-rangi ",
      "Paenga-whāwhā",
      "Haratua",
      "Pipiri ",
      "Hōngongoi",
      "Here-turi-kōkā",
      "Mahuru",
      "Whiringa-ā-nuku",
      "Whiringa-ā-rangi",
      "Hakihea",
    ],
    shortMonths: [
      "Koh",
      "Hui",
      "Pou",
      "Pae",
      "Har",
      "Pip",
      "Hōn",
      "Her",
      "Mah",
      "-nuku",
      "-rangi",
      "Hak",
    ],
  },
};
